import * as THREE from 'three';

import Simulator from './simulator';

export abstract class ThreeJSClass {
  _simulation: Simulator;

  constructor(simulation: Simulator) {
    this._simulation = simulation;
  }

  abstract onTick(elapsedTime: number): void;
  abstract onToggleTheme(isDarkMode: boolean): void;
  abstract onToggleDebug(isDebug: boolean): void;
  abstract dispose(): void;
}

interface ThreeJSColourDef {
  light: THREE.ColorRepresentation;
  dark: THREE.ColorRepresentation;
}

export const ThreeJSColours: { [key: string]: ThreeJSColourDef } = {
  background: {
    light: 0xeaeaea,
    dark: 0x2c2c2c,
  },
  fog: {
    light: 0xeaeaea,
    dark: 0x2c2c2c,
  },
  grid: {
    light: 0x000000,
    dark: 0xffffff,
  },
  ground: {
    light: 0xeaeaea,
    dark: 0x333333,
  },
};

export const easeInOutSine = (x: number) => -(Math.cos(Math.PI * x) - 1) / 2;

export interface ThreeJSRotation {
  x: number;
  y: number;
  z: number;
}

export const THEME_ELEMENT_ID = 'floppy-samples-root';
export const THEME_ELEMENT_CLASS = 'dark';
